import styled from 'styled-components'
import theme from 'live/services/theme'

export const Container = styled.div`
    width: 100%;
    padding: 15px 60px;
`

export const Header = styled.div`
    display: flex;
    font-size: 14px;
    width: 100%;
    justify-content: space-around;
    margin-bottom: 30px;
`

export const IconContainer = styled.div`
    display: flex;
    justify-content: space-between;

    i {
        cursor: pointer;
        padding: 5px;
        font-size: 13px;
        color: ${theme['link-color']};
    }
`
export const TextButton = styled.div`
    display: flex;
    justify-content: space-around;
    align-self: center;
    align-items: center;
    cursor: pointer;
    line-height: 14px;
    min-width: 118px;
    padding: 5px;
    border: none;
    background-color: var(--gray-0);
    color: ${theme['link-color']};
`
